import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function EFLogoutIcon() {
  const isDark = useAppSelector(isDarkTheme)
  const color = isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'
  return (
    <svg
      width='15'
      height='14'
      viewBox='0 0 15 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.5 8.25C5.91421 8.25 6.25 7.91422 6.25 7.5C6.25 7.08579 5.91421 6.75 5.5 6.75C5.08579 6.75 4.75 7.08579 4.75 7.5C4.75 7.91422 5.08579 8.25 5.5 8.25ZM8 0.500004C8 0.354204 7.93636 0.215666 7.82575 0.120678C7.71514 0.0256898 7.56857 -0.0162863 7.42445 0.00574443L0.424449 1.07574C0.180316 1.11306 0 1.32303 0 1.57V12.43C0 12.6769 0.180277 12.8869 0.424378 12.9243L7.42438 13.9953C7.56851 14.0173 7.71509 13.9754 7.82572 13.8804C7.93635 13.7854 8 13.6468 8 13.501V7.00002L13.1722 7.00002L12.1753 7.87372C11.9679 8.05556 11.9468 8.37144 12.1284 8.57926C12.3099 8.78708 12.6253 8.80814 12.8328 8.6263L14.8295 6.8763C14.9379 6.78135 15 6.64419 15 6.50001C15 6.35583 14.9379 6.21867 14.8295 6.12372L12.8328 4.37372C12.6253 4.19188 12.3099 4.21294 12.1284 4.42076C11.9468 4.62858 11.9679 4.94446 12.1753 5.1263L13.1723 6.00002L8 6.00002V0.500004ZM7 1.08224V12.9187L1 12.0007V1.99938L7 1.08224ZM9.5 13H9V8H10V12.5C10 12.7761 9.77614 13 9.5 13ZM9 5V1H9.5C9.77614 1 10 1.22386 10 1.5V5H9Z'
        fill={color}
      />
    </svg>
  )
}
